import GenericSettings from "../GenericSettings/GenericSettings";
import { cqAPI } from "../../lib/Auth";
import React, { useEffect, useState } from "react";
import { Button, Text, Flex } from "@chakra-ui/react";
import moment from "moment";

const getParam = (p)=>{
  const newSearchParams = new URLSearchParams(window.location.search);
  return newSearchParams.get(p);
}

const convertToGeneric = (template) => {
  return template?.map((section) => {
    return {
      title: section.title,
      description: section.description || "",
      inputs: section.questions.map((q) => ({
        type:
          q.type === "t"
            ? "input"
            : q.type === "yn"
            ? "switch"
            : q.type === "multiple"
            ? "select"
            : q.type === "ynwt"
            ? "switchwt"
            : q.type,
        options: q?.options?.length ? q?.options.map(option=>{
          if (typeof(option) === 'string'){
            return {
              label : option,
              value : option
            }
          }
          return option
        }) : [],
        id: q.id,
        hint: q.hint,
        name: q.name || q.text,
      })),
    };
  });
};

function PatientHistory() {
  const [active, setActive] = useState(null);
  const [completed, setCompleted] = useState(null);
  const [template, setTemplate] = useState(null);
  const [view, setView] = useState(null);
  const bid = getParam("bid");
  const uid = getParam("_uid");
  const and_bid_uid = bid && uid ? `&bid=${bid}&_uid=${uid}` : '';
  const q_bid_uid = bid && uid ? `?bid=${bid}&_uid=${uid}` : '';
  const fetchHistory = async () => {
    const response = await cqAPI.get(`/pp/history${q_bid_uid}`);
    setCompleted(response.data.completed);
    setActive(response.data.active);
    setTemplate(response.data.template);
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  return (
    <Flex
      direction="column"
      align="center"
      justify={view? "" : "center"}
      height="100vh"
      p={4}
      overflowY="auto"
      width="100%"
    >
      {!view && (
        <Flex justify="center" align="center" mb={4}>
          {completed && (
            <Flex direction="column" align="center" mx={2} minHeight="80px">
              <Button onClick={() => setView('view-completed')}>View Completed Questionnaire</Button>
              <Text fontSize="sm">Updated on {moment(completed.updated).format('LLL')}</Text>
            </Flex>
          )}
          {!completed && (
            <Flex direction="column" align="center" mx={2} minHeight="80px">
              <Button onClick={() => setView('complete')}>Complete the Questionnaire</Button>
            </Flex>
          )}
          {completed && active && (
            <Flex direction="column" align="center" mx={2} minHeight="80px">
              <Button onClick={() => setView('complete')}>Complete the New Questionnaire</Button>
            </Flex>
          )}
          {completed && !active && (
            <Flex direction="column" align="center" mx={2} minHeight="80px">
              <Button onClick={() => setView('update')}>Update</Button>
            </Flex>
          )}
        </Flex>
      )}

      {template && view === 'view-completed' && (
        <GenericSettings configuration={convertToGeneric(template.data)} endpoint={`/pp/read-history/${template._id}`} bid_uid={and_bid_uid} long_query={true} supportBatching={true} viewOnly={true} onClose={()=>setView('')} />
      )}
      {active && view === 'complete' && (
        <GenericSettings autoSave={true} configuration={convertToGeneric(active.data)} endpoint={`/pp/history/${active._id}`} bid_uid={and_bid_uid} long_query={true} supportBatching={true} onClose={()=>setView('')} />
      )}
      {template && view === 'update' && (
        <GenericSettings autoSave={true} configuration={convertToGeneric(template.data)} endpoint={`/pp/history/${template._id}`} bid_uid={and_bid_uid} long_query={true} supportBatching={true} onClose={()=>setView('')} />
      )}
    </Flex>
  );
}

export default PatientHistory;
